(function($) {
  async function duscounts() {
    let showDesignerDiscounts
    let showWholesaleDiscounts
    let cartTotalPrice = 0
    let buildTotalPrice = 0
    try {
      showDesignerDiscounts = productTags.designer
      showWholesaleDiscounts = productTags.wholesale && productTags.bundle === false
    } catch(e) {
      return
    }
    if(!!showDesignerDiscounts === false && !!showWholesaleDiscounts === false) return
    const discountPriceContainers = []
    $('.cpb-product-full-price').each(() => {
      discountPriceContainers.push($('<div class="cpb-custom-discounted-price">'))
    })
    updateCartPrice()
    document.addEventListener('cpb-add-to-cart', updateCartPrice)
    updateBuildPrice()
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', updateBuildPrice)
    $(document).on('mousedown, click', '.cpb-quantity-button', () => {
      setTimeout(updateBuildPrice, 1000)
    })

    function getDesignerDiscountPercent() {
      return cartTotalPrice + buildTotalPrice * 0.8 >= 10000 ? 20 : 0
    }
    function getFullDiscountPercent() {
      let wholesaleDiscountPercent = cartTotalPrice + buildTotalPrice * 0.6 >= 80000 ? 40 : 0
      return Math.max(getDesignerDiscountPercent(), wholesaleDiscountPercent)
    }
    function onPriceChange() {
      recountDiscounts()
    }
    function recountDiscounts() {
      let discountPercent = 0
      if(showWholesaleDiscounts) discountPercent = getFullDiscountPercent()
      else discountPercent = getDesignerDiscountPercent()
      const discountedPriceNumber = Math.round(buildTotalPrice - (buildTotalPrice / 100 * discountPercent)) / 100
      $('.cpb-product-full-price').each(function(i) {  
        discountPriceContainers[i].text('$' + discountedPriceNumber.toFixed(2))
        discountPriceContainers[i].toggleClass('cpb-custom-has-discount', discountPercent > 0)
        const price = $(this)
        price.toggleClass('cpb-custom-price-before-discount', discountPercent > 0)
        price.append(discountPriceContainers[i])
      })
    }    
    function updateBuildPrice() {
      const newPrice = CPB.getStore().getState().Product.price * 100
      console.log('update build price', newPrice, buildTotalPrice)
      if(buildTotalPrice === newPrice) return
      buildTotalPrice = newPrice
      onPriceChange()
    }
    async function updateCartPrice() {
      const productsInCartResponse = await fetch('/cart.js')
      const productsInCart = await productsInCartResponse.json()
      cartTotalPrice = productsInCart.total_price
      onPriceChange()
    }
  }
  
  const changeLoaderImage = {
    init() {
      setTimeout(this.changeLoaderImage, 60000)
      document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', () => {
        setTimeout(this.changeLoaderImage, 10000)
      }, {once: true})
      document.querySelector('.cpb-add-to-cart-button')?.addEventListener('click', this.changeLoaderImage)
    },
    changeLoaderImage: (function() {
      let changed = false      
      return function() {
        if(changed) return
        changed = true
        const style = document.createElement('style')
        style.setAttribute('data-custom-added-by-cpb', '')
        const addToCartImageUrl = 'https://cdn.shopify.com/s/files/1/0219/0619/4532/t/82/assets/adding_to_cart.gif?v=1662663880'
        style.innerText = '.cpb-loader-center::before {background-image: url(' + addToCartImageUrl + ')}'
        document.body.appendChild(style)
      }    
    })()
  }
  
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', init)
  document.addEventListener('cpb-add-to-cart', function(event) {
    const drawer = new theme.CartDrawer()
    drawer.open()
  })
  
  function init() {    
    changeLoaderImage.init()    
    hideTooltipOnScroll()
    // duscounts()
  }
  
  function hideTooltipOnScroll() {    
    setScrollOnce()
    
    function setScrollOnce() {
      document.addEventListener('scroll', function() {
        hideActiveTooltip()
        setTimeout(setScrollOnce, 1000)
      }, {once: true})
    }
    
    function hideActiveTooltip() {
    	const tooltip = document.querySelector('.Polaris-PositionedOverlay')
        if(!tooltip) return
        tooltip.style.display = 'none'
    }
  } 
})(jQuery)

  ;(function($) {
document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', init);

function init() {
modifyProductInCartInit();
}

function modifyProductInCartInit() {
if(window.location.search.indexOf('&modifyProduct=') === -1) return;
var keyId = window.location.search.split('&modifyProduct=')[1];
keyId = keyId.split('&')[0];
var addToCartBtn = $('.cpb-add-to-cart-button');
addToCartBtn.find('span').html('Update Cart');
addToCartBtn.on('click', function() {
$.get('/cart/change.js', {
'id': keyId,
'quantity': 0
});
});
}

})(jQuery);